import filtersCentersAndBosses from './filtersCentersAndBosses'

export default [...filtersCentersAndBosses]
